import React from "react";

import { ScoreProps } from "../interface";

import { TextScore, ContainerScore } from "./styles";

export const Score: React.FC<ScoreProps> = (props) => {

  const { img, handleCustomerScore, text } = props;

  return (
    <ContainerScore>
      <button type="button" onClick={() => handleCustomerScore(text)}>
        <img src={img} />
        <TextScore>{text}</TextScore>
      </button>
    </ContainerScore >
  );
};
